//
//
//  App Layout
//
//

import {Link, Outlet, useLocation} from "react-router-dom";

import classes from "./AppLayout.module.css"
import {Container, Group, Image, UnstyledButton, Badge} from "@mantine/core";
import {    
    IconDashboard,
    IconLogout,
    IconMessage2,
} from "@tabler/icons-react";

import logo from "../assets/logo.svg"
import { useContext } from "react";
import {generateColorFromString, getMetaContent} from "../utils.ts";
import { KeycloakContext } from "../components/KeycloakProvider";


function AppLayout() {
    const { keycloak } = useContext(KeycloakContext);
    const {pathname} = useLocation()

    const appName = getMetaContent("APP_NAME")

    const links = [
        {link: "/", label: 'Dashboard', icon: IconDashboard, active: pathname === "/"},
        {link: "/conversations", label: 'Conversations', icon: IconMessage2, active: pathname.startsWith("/conversations")}
    ]

    const handleLogout = () => {
        keycloak?.logout({ redirectUri: window.location.origin });
    };

    return (
        <>
            <nav className={classes.navbar}>
                <div className={classes.navbarMain}>
                    <Group className={classes.header} justify="center">
                        <Link to="/">
                            <Image
                                src={logo}
                                h={60}
                                w="auto"
                                fit="contain"
                            />
                        </Link>
                        {appName && <Badge mt="xs" color={generateColorFromString(appName)}>{appName}</Badge>}
                    </Group>
                    {links.map(link => {
                        
                        return (
                            <Link
                                className={classes.link}
                                data-active={link.active || undefined}
                                to={link.link}
                                key={link.link}
                            >
                                <link.icon className={classes.linkIcon} stroke={1.5}/>
                                <span>{link.label}</span>
                            </Link>
                        )
                        
                    })}
                </div>

                <div className={classes.footer}>
                    <UnstyledButton className={classes.link} onClick={handleLogout}>
                        <IconLogout className={classes.linkIcon} stroke={1.5}/>
                        <span>Logout</span>
                    </UnstyledButton>
                </div>
            </nav>
            <main className={classes.main}>
                <Container>
                    <Outlet/>
                </Container>
            </main>
        </>
    )
}

export default AppLayout
